
import React from "react";
import InternationalNewsletterSubscription from "@/components/articles/InternationalNewsletterSubscription";
import { motion } from "framer-motion";
import { Mail, Info, PiggyBank } from "lucide-react";

interface NewsletterSectionProps {
  language?: 'fi' | 'en' | 'sv' | 'ar' | 'he';
  hideTitle?: boolean;
  customTitle?: string;
}

const titles = {
  fi: "Liity postituslistallemme",
  en: "Join our mailing list",
  sv: "Prenumerera på vårt nyhetsbrev",
  ar: "انضم إلى قائمتنا البريدية",
  he: "הצטרף לרשימת התפוצה שלנו"
};

const descriptions = {
  fi: "Liittymällä postituslistallemme saat säännöllisesti asiantuntijoiden vinkkejä talouden hoitoon sekä tietoa parhaista lainatarjouksista.",
  en: "By joining our mailing list, you'll regularly receive expert tips on financial management and information on the best loan offers.",
  sv: "Genom att prenumerera på vårt nyhetsbrev får du regelbundet experttips om ekonomisk förvaltning och information om de bästa lånerbjudandena.",
  ar: "من خلال الانضمام إلى قائمتنا البريدية، ستتلقى بانتظام نصائح الخبراء حول الإدارة المالية ومعلومات عن أفضل عروض القروض.",
  he: "על ידי הצטרפות לרשימת התפוצה שלנו, תקבל באופן קבוע טיפים מומחים לניהול פיננסי ומידע על הצעות ההלוואות הטובות ביותר."
};

export const NewsletterSection: React.FC<NewsletterSectionProps> = ({
  language = "fi",
  hideTitle = false,
  customTitle
}) => {
  const isRtl = language === 'ar' || language === 'he';
  const displayTitle = customTitle || titles[language];
  
  return (
    <div id="newsletter-section-content" className="py-4 md:py-6">
      <motion.div 
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl mx-auto"
      >
        <div className="flex items-center justify-center mb-4">
          <div className="bg-blue-600 bg-opacity-10 p-2 rounded-full">
            <PiggyBank className="h-8 w-8 text-blue-600" />
          </div>
          <span className="ml-2 text-2xl font-bold text-blue-700 font-serif tracking-wide bg-gradient-to-r from-blue-700 to-blue-500 bg-clip-text text-transparent">Lainasampo.fi</span>
        </div>
        
        {!hideTitle && (
          <h2 className="text-3xl font-bold text-center mb-6">{displayTitle}</h2>
        )}
        
        {hideTitle && customTitle && (
          <h3 className="text-2xl font-semibold text-center mb-4 text-blue-700">{customTitle}</h3>
        )}
        
        <p className="text-gray-600 text-center mb-6 max-w-2xl mx-auto">{descriptions[language]}</p>
        
        <div className="bg-white rounded-lg shadow-sm p-6 max-w-2xl mx-auto">
          <InternationalNewsletterSubscription language={language} />
        </div>
      </motion.div>
    </div>
  );
};

export default NewsletterSection;
